import { render, staticRenderFns } from "./DadosBasicos.vue?vue&type=template&id=574f54c8&scoped=true"
import script from "./DadosBasicos.vue?vue&type=script&lang=js"
export * from "./DadosBasicos.vue?vue&type=script&lang=js"
import style0 from "./DadosBasicos.vue?vue&type=style&index=0&id=574f54c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f54c8",
  null
  
)

export default component.exports